import React from 'react'
import Skeleton from 'react-loading-skeleton'

import styles from './styles.module.css'

const ProductCardSkeleton = () => {
  return <Skeleton containerClassName={styles.container} width={'100%'} height={232} />
}

export default ProductCardSkeleton
